import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { authService } from '../services/authService';

/**
 * Higher-order component to protect routes that require authentication
 * Now checks for isLoggedIn flag instead of tokens
 */
const withAuth = (WrappedComponent) => {
  return (props) => {
    const history = useHistory();
    
    useEffect(() => {
      // Check if the user is logged in using our authService
      const isLoggedIn = authService.isLoggedIn();
      if (!isLoggedIn) {
        history.push('/login');
      }
    }, [history]);

    return <WrappedComponent {...props} />;
  };
};

export default withAuth; 